import { useEffect, useState } from 'react';
import { isBrowser } from '@spot-fe/utils';

// 参考文档 https://uponly.larksuite.com/wiki/X3UjwoR7aiCtBXkwf0LuIpYHszc
// 我们不少项目要求最小宽度为 1280px
const MOBILE_MAX_WIDTH = 840;

export const useIsMobile = (maxWidth: number = MOBILE_MAX_WIDTH) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  const handleResize = () => {
    if (isBrowser && document?.body?.offsetWidth < maxWidth) {
      setIsMobile(true);
      return;
    }
    setIsMobile(false);
  };

  useEffect(() => {
    handleResize();
    window?.addEventListener('resize', handleResize);
  }, []);

  return {
    isMobile,
  };
};
